export enum ProfileTab {
  PROFILE = 'PROFILE',
  ACCA_RESULTS = 'ACCA_RESULTS',
  PHS_RESULTS = 'PHS_RESULTS',
  RECOMMEND_SERVICE = 'RECOMMEND_SERVICE',
}

export type ProfileTabType = keyof typeof ProfileTab;
